import type { SVGComponentProps } from 'BreetHelpers';

export const IdentityVerification = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='100'
		height='100'
		viewBox='0 0 100 100'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<g clipPath='url(#clip0_9946_140563)'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M1.76538 78.8618C3.21226 59.5764 19.4445 44.2444 39.0839 44.2444C58.7232 44.2444 74.9554 59.5762 76.4023 78.8618C76.5167 80.3854 75.3269 81.6676 73.799 81.6676H4.3689C2.84077 81.6676 1.65132 80.3856 1.76538 78.8618Z'
				fill='#FFDA2D'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M35.7939 44.3915C36.8787 44.2958 37.9754 44.2444 39.0838 44.2444C58.723 44.2444 74.9553 59.5762 76.4021 78.8618C76.5166 80.3854 75.3268 81.6676 73.7988 81.6676H67.2189C68.7469 81.6676 69.9367 80.3854 69.8223 78.8618C68.4572 60.6647 53.9277 45.9903 35.7939 44.3915Z'
				fill='#FFC700'
			/>
			<path
				d='M41.889 42.07C52.9479 40.5173 60.6542 30.2936 59.1014 19.2347C57.5487 8.17575 47.325 0.469466 36.2661 2.02218C25.2072 3.57489 17.5009 13.7986 19.0536 24.8575C20.6063 35.9164 30.8301 43.6227 41.889 42.07Z'
				fill='#FFD6BD'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M39.0838 1.83923C38.1428 1.83923 37.2174 1.90486 36.3105 2.02927C46.1687 3.38123 53.7635 11.8355 53.7635 22.0652C53.7635 32.2949 46.1687 40.7492 36.3105 42.1012C37.2174 42.2256 38.1428 42.2912 39.0838 42.2912C50.2543 42.2912 59.31 33.2357 59.31 22.0652C59.31 10.8947 50.2543 1.83923 39.0838 1.83923Z'
				fill='#F9C6AA'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M75.6529 98.1608L61.4654 87.9639C56.0211 84.0506 53.0635 78.2824 53.0635 71.5776V53.4688C61.625 48.0758 68.6389 45.3795 75.6529 45.3795C82.6668 45.3795 89.6807 48.076 98.2424 53.4688V71.578C98.2424 78.2828 95.2848 84.051 89.8404 87.9643L75.6529 98.1608Z'
				fill='#64B5F6'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M75.6531 98.1607L73.2852 96.459L87.4725 86.2621C92.9168 82.3488 95.8744 76.5807 95.8744 69.8758V52.0234C96.651 52.4814 97.4398 52.9633 98.2424 53.4688V71.5779C98.2424 78.2828 95.2848 84.051 89.8404 87.9643L75.6531 98.1607Z'
				fill='#42A5F5'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M75.6529 90.9451L86.4207 83.2061C90.333 80.3942 92.383 76.3957 92.383 71.5778V56.7641C87.2818 53.7938 81.526 51.2389 75.6529 51.2389C69.7799 51.2389 64.0242 53.794 58.9229 56.7641V71.5778C58.9229 76.3955 60.9727 80.3942 64.885 83.2061L75.6529 90.9451Z'
				fill='#EFF4F7'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M75.6527 90.9451L77.8592 89.3593L67.0914 81.6203C63.1791 78.8084 61.1293 74.8097 61.1293 69.992V55.5326C60.3816 55.9306 59.6457 56.3431 58.9229 56.764V71.5777C58.9229 76.3955 60.9727 80.3941 64.885 83.206L75.6527 90.9451Z'
				fill='#E2E3E3'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M82.296 65.3926C83.519 64.1629 85.5073 64.1573 86.7372 65.3803C87.9669 66.6032 87.9725 68.5916 86.7495 69.8213L76.0647 80.6065C74.8499 81.828 72.8801 81.8414 71.6485 80.643L66.2174 75.3495C64.9741 74.1401 64.9465 72.1516 66.1559 70.9084C67.3653 69.6651 69.3538 69.6375 70.5969 70.8469L73.7995 73.9688L82.296 65.3926Z'
				fill='#E2E3E3'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M81.4844 63.485C82.7075 62.2553 84.6958 62.2497 85.9256 63.4727C87.1553 64.6956 87.161 66.684 85.938 67.9137L75.2532 78.6989C74.0383 79.9204 72.0684 79.9338 70.837 78.7354L65.4059 73.4419C64.1626 72.2325 64.135 70.244 65.3444 69.0008C66.5538 67.7575 68.5422 67.7299 69.7854 68.9393L72.988 72.0612L81.4844 63.485Z'
				fill='#64B5F6'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M86.6964 64.7227C87.0505 65.8082 86.7983 67.0486 85.9378 67.9139L75.253 78.699C74.0382 79.9205 72.0682 79.934 70.8368 78.7355L65.4057 73.442C64.5176 72.5781 64.2501 71.3172 64.6102 70.2139C64.763 70.6822 65.0282 71.1215 65.4057 71.4889L70.8368 76.7824C72.0682 77.9809 74.0382 77.9674 75.253 76.7459L85.9378 65.9607C86.2962 65.6004 86.5489 65.175 86.6964 64.7227Z'
				fill='#42A5F5'
			/>
		</g>
		<defs>
			<clipPath id='clip0_9946_140563'>
				<rect
					width='100'
					height='100'
					fill='white'
				/>
			</clipPath>
		</defs>
	</svg>
);
